var render = function render(){var _vm=this,_c=_vm._self._c;return _c('skeleton-wrapper',{attrs:{"show_loading":_vm.show_loading,"skeleton_count":_vm.skeleton_count,"skeleton_type":"image, card-heading, list-item, actions","skeleton_height":"380","skeleton_col_props":{ cols: '12', sm: '6', lg: '4' }}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }